<div class="calculator" (click)="hide() ">
    <div class="calculator__left">
        <div class="top_content">
            <img src="assets/img/svg/logo_login.svg" alt="" srcset="">
            <h6>Projection Calculator</h6>
            <h2>Turning Lost Revenue Into Monthly  Income</h2>
        </div>
        <div class="slider_box">

            <div class="row mb-4">
                <div class="col-lg-9">
                    <div class="content">
                        <h5>New Clients/Patients Per Month</h5>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="values notranslate">
                        <p>{{data_calc.plan_growth}}</p>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="rangeslider">
                        <input type="range" min="1" step="1" max="200" [(ngModel)]="data_calc.plan_growth"
                            (input)="calculateCalc(true)" class="slider">
                        <div class="slider blue"
                            [ngStyle]="{'clip-path': getSize(4, 1, 200)[0],'-webkit-clip-path': getSize(4, 1, 200)[0]}">
                        </div>
                        <div class="slider grey"
                            [ngStyle]="{'clip-path': getSize(4, 1, 200)[1],'-webkit-clip-path': getSize(4, 1, 200)[1]}">
                        </div>
                    </div>
                    <div class="rangeslider-value">
                        <span class="notranslate">1</span>
                        <span class="notranslate"> 200</span>
                    </div>
                </div>
               
            </div>
            <div class="row mb-4">
                <div class="col-lg-9">
                    <div class="content">
                        <h5>Average Service Amount</h5>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="values notranslate">
                        <p>{{data_calc.avg_plan | currency:'$':'symbol':'1.0-0'}}</p>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="rangeslider">
                        <input type="range" min="1000" step="100" max="10000" [(ngModel)]="data_calc.avg_plan"
                            (input)="calculateCalc(true)" class="slider">
                        <div class="slider blue"
                            [ngStyle]="{'clip-path': getSize(1, 1000, 10000)[0],'-webkit-clip-path': getSize(1, 1000, 10000)[0]}">
                        </div>
                        <div class="slider grey"
                            [ngStyle]="{'clip-path': getSize(1, 1000, 10000)[1],'-webkit-clip-path': getSize(1, 1000, 10000)[1]}">
                        </div>
                    </div>
                    <div class="rangeslider-value">
                        <span class="notranslate">{{ 1000 | currency:'$':'symbol':'1.0-0' }}</span>
                        <span class="notranslate"> {{ 10000 | currency:'$':'symbol':'1.0-0' }}</span>
                    </div>
                </div>
               
            </div>
            <div class="row mb-4">
                <div class="col-lg-9">
                    <div class="content">
                        <h5>Average Contract Term</h5>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="values notranslate">
                        <p style="    white-space: nowrap;">{{data_calc.avg_term}} months</p>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="rangeslider">
                        <input type="range" min="12" step="1" max="48" [(ngModel)]="data_calc.avg_term"
                            (input)="calculateCalc(true)" class="slider">
                        <div class="slider blue"
                            [ngStyle]="{'clip-path': getSize(2, 12, 48)[0],'-webkit-clip-path': getSize(2, 12, 48)[0]}">
                        </div>
                        <div class="slider grey"
                            [ngStyle]="{'clip-path': getSize(2, 12, 48)[1],'-webkit-clip-path': getSize(2, 12, 48)[1]}">
                        </div>
                    </div>
                    <div class="rangeslider-value">
                        <span class="notranslate">12 months</span>
                        <span class="notranslate"> 48 months</span>
                    </div>
                </div>
               
            </div>

        </div>

        <div class="button-wrapper">
            <!-- <button class="button__primary">Calculate</button> -->
            <button class="button__reset" (click)="resetCalc()">Reset </button>
        </div>
    </div>
    <div class="calculator__right" >
        <div class="view_type">
            <div class="graph" [class.active]="viewType == 'graph'" (click)="viewType = 'graph'">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.83301 11.6666L8.33301 9.16659L9.99967 10.8333L12.4997 8.33325L14.1663 9.99992M3.33301 14.9999V4.99992C3.33301 4.55789 3.5086 4.13397 3.82116 3.82141C4.13372 3.50885 4.55765 3.33325 4.99967 3.33325H14.9997C15.4417 3.33325 15.8656 3.50885 16.1782 3.82141C16.4907 4.13397 16.6663 4.55789 16.6663 4.99992V14.9999C16.6663 15.4419 16.4907 15.8659 16.1782 16.1784C15.8656 16.491 15.4417 16.6666 14.9997 16.6666H4.99967C4.55765 16.6666 4.13372 16.491 3.82116 16.1784C3.5086 15.8659 3.33301 15.4419 3.33301 14.9999Z" stroke="#566D82" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>
                    Graph
                </span>
            </div>

            <div class="graph table" (click)="viewType = 'table'" [class.active]="viewType == 'table'">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.33301 4.99992C3.33301 4.55789 3.5086 4.13397 3.82116 3.82141C4.13372 3.50885 4.55765 3.33325 4.99967 3.33325H14.9997C15.4417 3.33325 15.8656 3.50885 16.1782 3.82141C16.4907 4.13397 16.6663 4.55789 16.6663 4.99992V6.66659C16.6663 7.10861 16.4907 7.53254 16.1782 7.8451C15.8656 8.15766 15.4417 8.33325 14.9997 8.33325H4.99967C4.55765 8.33325 4.13372 8.15766 3.82116 7.8451C3.5086 7.53254 3.33301 7.10861 3.33301 6.66659V4.99992Z" stroke="#566D82" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M3.33301 13.3333C3.33301 12.8912 3.5086 12.4673 3.82116 12.1547C4.13372 11.8422 4.55765 11.6666 4.99967 11.6666H14.9997C15.4417 11.6666 15.8656 11.8422 16.1782 12.1547C16.4907 12.4673 16.6663 12.8912 16.6663 13.3333V14.9999C16.6663 15.4419 16.4907 15.8659 16.1782 16.1784C15.8656 16.491 15.4417 16.6666 14.9997 16.6666H4.99967C4.55765 16.6666 4.13372 16.491 3.82116 16.1784C3.5086 15.8659 3.33301 15.4419 3.33301 14.9999V13.3333Z" stroke="#566D82" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>                    
                <span>
                    Table
                </span>
            </div>
                
        </div>
        <h3>Let’s see how your business will do in</h3>
        <div class="tabs">
            <ul>
                <li *ngFor="let item of monthsArray;let i=index " [class.active]="selectedTbas == i" (click)="selectedTbas = i; customMonth = null; setMonthValue(item);"> {{item}} mo</li>
                <li class="custom" [class.active]="selectedTbas == -1" (click)="selectedTbas = -1; showAddBox= true; $event.stopPropagation();" >
                    {{ (!customMonth || showAddBox) ? '+ Custom' : customMonth + ' mo'}}
                    <svg style="margin-left:7px;" *ngIf="!(!customMonth || showAddBox)" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.00033 4.33333L11.667 7M2.66699 13.3333H5.33366L12.3337 6.33333C12.6873 5.97971 12.8859 5.50009 12.8859 5C12.8859 4.4999 12.6873 4.02029 12.3337 3.66666C11.98 3.31304 11.5004 3.11438 11.0003 3.11438C10.5002 3.11438 10.0206 3.31304 9.66699 3.66666L2.66699 10.6667V13.3333Z" stroke="white" stroke-opacity="0.6" stroke-linecap="round" stroke-linejoin="round" style="stroke: #fff !important; "/>
                    </svg>
                        
                    <div class="custom_block" *ngIf="showAddBox">
                        <input type="number" name="" id="" [(ngModel)]="customMonth" [max]="60" [min]="0" (blur)="enforceMinMax()" >
                        <span (click)="setMonthValue(customMonth); $event.stopPropagation();" class="add">Add</span> 
                        <span class="month" >Month</span>
                    </div>
                 </li>
            </ul>
        </div>

        <ng-container *ngIf="denefit_monthly_revenue.length>0 && viewType == 'graph'">
            <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions"
                style="width: 100%; height: calc(100vh - 400px); display: block;"></highcharts-chart>
        </ng-container>
        <ng-container *ngIf="denefit_monthly_revenue.length>0 && viewType == 'table'">
            <div  class="tableWrapper">
                <div class="tableWrapper__head">
                    <b>Month(s)</b>
                    <b>Earnings </b>
                </div>
                <div class="tableWrapper__body">
                    <div class="tableWrapper__row" *ngFor="let item of denefit_monthly_revenue; let i=index">
                        <span>{{i + 1}} Month{{i != 0 ? 's':''}}</span>
                        <b>{{item | currency: '$'}}</b>
                    </div>
                </div>
            </div>
        </ng-container>



        <div class="cost_waiting_box">

            <div class="cost_waiting_box__left">
                <h6>Implementation Period</h6>
                <div class="custom_block removePostion" >
                    <input type="number" name="" id="" appNumbersOnly  [(ngModel)]="implementationPeriod"  (ngModelChange)="getCostOfwaiting()" style="width: 150px;" [attr.max]="maxImplementationPeriod"  (blur)="enforceMinMaxPeriod()">
                    <!-- <span >Days</span>  -->
                    <select (input)="onSelecDropDown($event.target.value)" name="" id="" style="" class="select_dropdown">
                        <option value="0">Days</option>
                        <option value="1">Months</option>
                    </select>
                </div>
            </div>
            <div class="cost_waiting_box__right">
                <h6 class="d-flex align-item-center justify-content-center mb-0"><svg style=" margin-right: 8px;" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 5.83337L8 10.8334L11.3333 7.50004L18 14.1667M18 14.1667V8.33337M18 14.1667H12.1667" stroke="#FF6F6F" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                     Cost of Waiting</h6>
                <div class="value">-{{cost_of_waiting | currency:'$'}}</div>
            </div>
        </div>


    </div>
</div>